import { DigitalWalletType } from './';

export class DigitalWalletPaymentDetails {
	authenticationPaymentToken: string;
	digitalWalletType: DigitalWalletType;
	isCreditCard: boolean;
	isDebitCard: boolean;
	accountName?: string;
	address?: string;
	zipCode: string;
	paymentAmount?: number;
	discountAmount?: number | null;
	calculatedServiceFee?: number;
	description?: string;
	email?: string;
	isEmailOptedIn?: boolean;
	customFields?: Array<string>;
}
